/* This class is a bit different from other models.
    It is a wrapper for the job and workreport models and collections.
    Deppending on what is contained it will behave like a job or a workreport.
    You can figure out which by running isJob or isWorkReport
    This model is made for viewing and attesting only.
    // Joakim
 */

var Attestable = Backbone.Model.extend({
    jobUrlRoot: Core.contextRoot + '/job',
    workReportUrlRoot: Core.contextRoot +'/report',
    editGroupPermission: 'admin_jobs',

    initialize: function(attributes, options) {
        if (options && options.jobUrlRoot) this.jobUrlRoot = options.jobUrlRoot;
        if (options && options.workReportUrlRoot) this.workReportUrlRoot = options.workReportUrlRoot;
        if (options && options.jobId)
            this.jobId = options.jodId;
        else if (options && options.workReportId)
            this.workReportId = options.workReportId;
        //this.id = this.cid;
        if (options.id)
            this.id = options.id
        if (this.isJob())
            this.id = this.jobId;
        else (this.isWorkReport())
            this.id = this.workReportId;

    },

    isEditable: function() {
        if(this.isJob()) {
            return this.job.isEditable();
        } else if (this.isWorkReport()) {
            return this.workReport.isEditable();
        }
    },
    isSelectable: function(includeReports) {
        //var selectable = this.hasAnythingToAttest && this.hasAnythingToAttest() && this.isAttestable() || this.isPublishable();
        //if (includeReports)
        //    selectable |= this.job && this.job.reports && this.job.reports.filter(function(report){return report.isSelectable()}).length > 0;
        return this.hasAnythingToAttest && this.hasAnythingToAttest() && this.isAttestable() || this.isPublishable();
    },

    hasSelectable: function() {
        //var selectable = this.job && this.job.reports && this.job.reports.filter(function(report){return report.isSelectable()}).length > 0;
        return this.job && this.job.reports && this.job.reports.filter(function(report){return report.isSelectable()}).length > 0;
    },

    isAttestable: function() {
        if(this.isJob()) {
            return this.job.isAttestable();// || (this.job.reports && this.job.reports.filter(function(report){return report.isAttestable()}).length == this.job.reports.length);
        } else if (this.isWorkReport()) {
            return this.workReport.isAttestable();
        }
    },

    isPublishable: function() {
        if(this.isJob()) {
            return this.job.isEditable() && !this.job.isPublished() || (this.job.get('attestedTimeStamp') && Core.client.hasGroupPermission(this.job.get('groupId'), 'attest_work_reports'));
        } else if (this.isWorkReport()) {
            return this.workReport.isPublishable();
        }
    },

    isDeletable: function() {
        return false;
    },

    isToBeInvoiced: function() {
        if(this.isJob()) {
            return this.job.isToBeInvoiced(); // TODO: JOBS
        } else if (this.isWorkReport()) {
            return this.workReport.isToBeInvoiced();
        }
    },

    getTotalHours: function(includeAddOn) {
        if(this.isJob()) {
            var total = 0;
            if (this.job.reports) {
                for (var i = 0; i < this.job.reports.length; i++) {
                    total += this.job.reports[i].getTotalHours(includeAddOn);
                }
            }
            return total;
        } else if (this.isWorkReport()) {
            return this.workReport.getTotalHours(includeAddOn);
        }
    },

    getTotalInvoicedHours: function(includeAddOn) {
        if(this.isJob()) {
            var total = 0;
            if (this.job.reports) {
                for (var i = 0; i < this.job.reports.length; i++) {
                    total += this.job.reports[i].getTotalInvoicedHours(includeAddOn);
                }
            }
            return total;
        } else if (this.isWorkReport()) {
            return this.workReport.getTotalInvoicedHours(includeAddOn);
        }
    },

    defaults: function() {
        return {
            job: null,
            workReport: null
        }
    },

    setFromJob: function(job) {
        this.job = job;
        this.id = job ? job.id : this.id;
        this.workReport = null;
    },

    setFromWorkReport: function(workReport) {
        this.workReport = workReport;
        this.id = workReport ? workReport.id : this.id;
        this.job = null;
    },

    hasAnythingToAttest: function(){
        if (this.isJob())
            return this.job.get('items') && this.job.get('items').length > 0 && this.job.get('items').filter(function(item){ return item.articleInvoiced}).length > 0;
        else
            return true;
    },

    hasChildrenToAttest: function(){
        if (this.isJob()){
            if (this.job.reports && this.job.reports.filter(function(report){return report.workReport.get('attestedTimeStamp') == null}).length > 0)
                return true;
            return false;
        }
        else return false;
    },

    isJob: function() {
        return this.job != null;
    },

    isWorkReport: function() {
        return this.workReport != null;
    },

    attest: function() {
        if (this.isJob()) {
            return this.job.attest();
        } else if (this.isWorkReport()) {
            return this.workReport.attest();
        }
    },

    publish: function() {
        if (this.isJob()) {
            return this.job.publish();
        } else if (this.isWorkReport()) {
            return this.workReport.publish();
        }
    },

    fetch: function(){
    /*    if (this.jobId) {
            this.setFromJob(new Job({id: this.jobId}));
            return this.job.fetch();
        } else if (this.workReportId) {
            this.setFromWorkReport(new WorkReport({id: this.workReportId}));
            return this.workReport.fetch();
        } else if (this.job) {
            return this.job.fetch();
        } else if (this.workReport) {
            return this.workReport.fetch();
        }//*/
    },

    get: function(key) {
        if (key === "workReport") {
            return this.workReport;
        } else if (key === "job") {
            return this.job;
        } else if (this.isJob()) {
            return this.job.get(key);
        } else if (this.isWorkReport()) {
            return this.workReport.get(key);
        }
    },

    invoicedTotalPrice: function() {
        if(this.isWorkReport) {
            return this.get("workReport").invoicedTotalPrice();
        } else if (this.isJob()) {
            return 0; // TODO JOB
        }
    },

    sumInvoicedPrice: function(unit, onlyInvoiced, onlyWorkHours) {
        if(this.isWorkReport()) {
            return this.get("workReport").sumInvoicedPrice(unit, onlyInvoiced, onlyWorkHours);
        } else if (this.isJob()) {
            return 0; // TODO JOB
        }
    },

    sumAmountsByUnit: function(unit, includeAddOn, requireWorkHours) {
        if(this.isJob()) {
            return this.job.sumAmountsByUnit(unit, includeAddOn, requireWorkHours);
        } else if (this.isWorkReport()) {
            return this.workReport.sumAmountsByUnit(unit, includeAddOn, requireWorkHours);
        }
    },

    sumAmountsByArticle: function(articleId) {
        if(this.isJob()) {
            return this.job.sumAmountsByArticle(articleId);
        } else if (this.isWorkReport()) {
            return this.workReport.sumAmountsByArticle(articleId);
        }
    },

    hasSpecificInvoicedAmount: function(unit) {
        if(this.isJob()) {
            return this.job.hasSpecificInvoicedAmount(unit);
        } else if (this.isWorkReport()) {
            return this.workReport.hasSpecificInvoicedAmount(unit);
        }
    },

    hasOnlyInvoicedAmount: function(unit) {
        if(this.isJob()) {
            return this.job.hasOnlyInvoicedAmount(unit);
        } else if (this.isWorkReport()) {
            return this.workReport.hasOnlyInvoicedAmount(unit);
        }
    },

    hasAnyAmount: function(unit) {
        if(this.isJob()) {
            return this.job.hasAnyAmount(unit);
        } else if (this.isWorkReport()) {
            return this.workReport.hasAnyAmount(unit);
        }
    },

    sumAmountsToInvoice: function(unit) {
        if(this.isJob()) {
            return this.job.sumAmountsToInvoice(unit);
        } else if (this.isWorkReport()) {
            return this.workReport.sumAmountsToInvoice(unit);
        }
    },

    isPriced: function(unit) {
        if(this.isJob()) {
            return this.job.isPriced(unit);
        } else if (this.isWorkReport()) {
            return this.workReport.isPriced(unit);
        }
    },

    itemsWithArticle: function(articleId) {
        if(this.isJob()) {
            return this.job.itemsWithArticle(articleId);
        } else if (this.isWorkReport()) {
            return this.workReport.itemsWithArticle(articleId);
        }
    },

    fetchItemPrices: function(options) {
        if(this.isJob()) {
            return this.job.fetchItemPrices(options);
        } else if (this.isWorkReport()) {
            return this.workReport.fetchItemPrices(options);
        }
    },

    itemsWithUnit: function(unit) {
        if(this.isJob()) {
            return this.job.itemsWithUnit(unit);
        } else if (this.isWorkReport()) {
            return this.workReport.itemsWithUnit(unit);
        }
    },

    isInvoiced: function() {
        return this.get('invoicedTimeStamp');
    },

    titleExtended: function() {
        if(this.isJob()) {
            return this.job.get("title") // TODO extended title?
        } else if (this.isWorkReport()) {
            return this.workReport.titleExtended();
        }
    },

    totalPrice: function() {
        if(this.isJob()) {
            return this.job.totalPrice();
        } else if (this.isWorkReport()) {
            return this.workReport.totalPrice();
        }
    },

    reports: function() {
        if(this.isWorkReport()) return false;
        return this.job.reports && this.job.reports.length > 0 ? this.job.reports : false;
    }

});

/*
    Functions have to bubble up to the workreport and job collectionns
    Here be dragons
    // Joakim
 */
var Attestables = Backbone.Collection.extend( {
    model: Attestable,
    reportsFilterKey: 'attestReports.filterParams',
    jobsFilterKey: 'attestJobs.filterParams',
    defaultFilterParams: {
        path: 'all',
        from: null,
        to:null
    },

    jobUrl: function(options) {
        return this.jobCollection.url(options);
    },

    workReportUrl: function(options) {
        return this.workReportCollection.url(options);
    },

    saveFilter: function() {
        this.jobCollection.saveFilter();
        this.workReportCollection.saveFilter();
    },

    initialize: function(models, options) {
        Backbone.Collection.prototype.initialize.call(this, models, options);
        this.filterParams = _(this.defaultFilterParams).clone();
        var reportModels = [];
        var jobModels = [];
        for (var i in models) {
            if(models[i].isJob()) {
                jobModels.push(models[i]);
            } else if(models[i].isWorkReport()) {
                reportModels.push(models[i]);
            }
        }
        this.workReportCollection = new WorkReports(reportModels, options);
        this.jobCollection = new Jobs(jobModels, options);
        //this.jobCollection.jobListPath('/job/attestlist');
        /*if(models) {
            this.set(models);
        }*/

        this.filterParams = _(this.defaultFilterParams).clone();

        if (options && options.filterParams)
            _(this.filterParams).extend(options.filterParams);
		else if (this.reportsFilterKey in sessionStorage)
            this.filterParams = JSON.parse(sessionStorage[this.reportsFilterKey]);
		if (! 'path' in this.filterParams)
			this.filterParams.path = 'all';
    },

    get:function(key, type) {
        var result = Backbone.Collection.prototype.get.call(this, key);
        if (result == null || typeof result === "undefined") {
            if (type && type == "workReport") {
                return this.workReportCollection.get(key);
            } else if (type && type == "job") {
                return this.jobCollection.get(key);
            } else {
                result = this.workReportCollection.get(key);
                if (result == null || typeof result === "undefined") {
                    return this.jobCollection.get(key);
                } else {
                    return result;
                }
            }
        } else {
            return result;
        }
    },

    set: function(models, options) {
        if (models == null) return;
        Backbone.Collection.prototype.set.call(this, models, options);
        options = _.extend({}, this.setOptions, options);
        if (options.parse && !this._isModel(models)) {
            models = this.parse(models, options) || [];
        }

        var singular = !_.isArray(models);
        models = singular ? [models] : models.slice();
        if(models.isJob && models.isWorkReport) {  // Does it have these funcitons?
            if(models.isJob()) {
                this.jobCollection.set(models.get("job"), options);
            } else if (models.isWorkReport()) {
                this.workReportCollection.set(models.get("workReport"), options);
            }
        } else {
            var reportModels = [];
            var jobModels = [];
            _(models).each(function (model) {
                if (model.workReport == null && model.job == null) return;
                if (model.isJob()) {
                    jobModels.push(model.job);
                } else if (model.isWorkReport()) {
                    reportModels.push(model.workReport);
                }
            });
            this.workReportCollection.set(reportModels, options);
            this.jobCollection.set(jobModels, options);
        }
        this.setReportsToJob();
    },

    reset: function(models) {
        if (models == null) return;

        var singular = !_.isArray(models);
        models = singular ? [models] : models.slice();
        if(models.isJob && models.isWorkReport) {  // Does it have these funcitons?
            if(models.isJob()) {
                this.jobCollection.reset(models.get("job"));
            } else if (models.isWorkReport()) {
                this.workReportCollection.reset(models.get("workReport"), options);
            }
        } else {
            var reportModels = [];
            var jobModels = [];
            _(models).each(function (model) {
                if (model.workReport == null && model.job == null) return;
                if (model.isJob()) {
                    jobModels.push(model.job);
                } else if (model.isWorkReport()) {
                    reportModels.push(model.workReport);
                }
            });
            this.workReportCollection.reset(reportModels);
            this.jobCollection.reset(jobModels);
        }
        Backbone.Collection.prototype.reset.call(this, models);
        this.setReportsToJob();
    },

    setupWorkReports: function() {
            this.workReportCollection.searchQuery = this.searchQuery;
            this.workReportCollection.reportsFilterKey = this.reportsFilterKey;// 'attest.reportsFilterKey';
            this.workReportCollection.defaultFilterParams.includeAttested = false;
            this.workReportCollection.defaultFilterParams.includeInvoiced = false;
            this.workReportCollection.defaultFilterParams.includeClosed = false;
            this.workReportCollection.defaultFilterParams.to = this.defaultFilterParams.to;
            this.workReportCollection.defaultFilterParams.from = this.defaultFilterParams.from;
            this.workReportCollection.filterParams = this.filterParams;
            this.workReportCollection.filterParams.types = ['null','STANDALONE','RESOURCE'];
    },

    setupJobs: function() {
        this.jobCollection.searchQuery = this.searchQuery;
        this.jobCollection.jobsFilterKey = this.jobsFilterKey;
        delete(this.jobCollection.filterParams.type);
        this.jobCollection.filterParams = this.filterParams;
        this.jobCollection.filterParams.states = ['FINISHED'];
        if (this.jobCollection.filterParams.includeClosed)
            this.jobCollection.filterParams.states.push('CLOSED')
        this.jobCollection.filterParams.includeItems = true;
        this.jobCollection.filterParams.noCache = true;
        this.jobCollection.filterParams.includeWorkedDates = true;
    },

    fetch: function(options){
        //console.log("Attestables Collection:","Fetching Jobs and WorkReports")
        var self = this;
        self.setupJobs();
        self.setupWorkReports();
        var result = [];
        return $.when(self.jobCollection.fetch(options).success(function() {
            //console.log("Attestables Collection:", "Finished fetching Jobs: found " + self.jobCollection.models.length + " jobs.")
            for (var i in self.jobCollection.models) {
                var attestable = new Attestable(null,{id: self.jobCollection.models[i].id});
                attestable.setFromJob(self.jobCollection.models[i]);
                result.push(attestable);
            }
        }), self.workReportCollection.fetch(options).success(function() {
            //console.log("Attestables Collection:", "Finished fetching WorkReports: found " + self.workReportCollection.models.length + " reports.")
            for (var i in self.workReportCollection.models) {
                var attestable = new Attestable(null,{id: self.workReportCollection.models[i].id});
                attestable.setFromWorkReport(self.workReportCollection.models[i]);
                result.push(attestable);
            }
        })).then(function (success) {
            //console.log("Attestables Collection:", "Fetching Attestables completed, found " + self.models.length + " attestables");
            self.setReportsToJob();
            self.reset(result);
        });
    },

    fetchUpdates: function(options) {
        //console.log("Attestables Collection:","Fetching Updates Jobs and WorkReports")
        var self = this;
        self.setupJobs();
        self.setupWorkReports();
        var result = [];
        return $.when(self.jobCollection.fetchUpdates(options).success(function() {
            //console.log("Attestables Collection:", "Finished fetchUpdates Jobs: found " + self.jobCollection.models.length + " jobs.")
            for (var i in self.jobCollection.models) {
                var attestable = new Attestable(null,{id: self.jobCollection.models[i].id});
                attestable.setFromJob(self.jobCollection.models[i]);
                result.push(attestable);
            }
        }), self.workReportCollection.fetchUpdates(options).success(function() {
            //console.log("Attestables Collection:", "Finished fetchUpdates WorkReports: found " + self.workReportCollection.models.length + " reports.")
            for (var i in self.workReportCollection.models) {
                var attestable = new Attestable(null,{id: self.workReportCollection.models[i].id});
                attestable.setFromWorkReport(self.workReportCollection.models[i]);
                result.push(attestable);
            }
        })).then(function (success) {
            //console.log("Attestables Collection:", "Fetching Attestables completed, found " + self.models.length + " attestables");
            self.setReportsToJob();
            self.reset(result);
        });
    },

    getTotalHours: function(includeAddOn) {
        var total = 0;
        _(this.models).each(function(attestable) {
            if (attestable.isJob() || attestable.get('type') != 'ABSENCE') {
                if (attestable.isWorkReport()) {
                    total += attestable.get("workReport").getTotalHours(includeAddOn); // TODO JOB
                } else if (attestable.isJob()) {
                    total += attestable.getTotalHours(includeAddOn);
                }
            }
        }, this);
        return total;
    },

    getTotalInvoicedHours: function(includeAddOn) {
        var total = 0;
        for (var i = 0; i < this.models.length; i++) {
            total += this.models[i].getTotalInvoicedHours(includeAddOn);
        }
        return total;
    },

    getTotalAbsenceHours: function(activityId) {
        return this.workReportCollection.getTotalAbsenceHours(activityId); // TODO JOB
    },

    sumAmountsByUnit: function(unit, includeAddOn, requireWorkHours) {
        return this.workReportCollection.sumAmountsByUnit(unit, includeAddOn, requireWorkHours);
    },

    sumAmountsByArticle: function(articleId) {
        return this.workReportCollection.sumAmountsByArticle(articleId);
    },

    sumInvoicedAmountsByUnit: function(unit, includeAddOn, requireWorkHours) {
        return this.workReportCollection.sumInvoicedAmountsByUnit(unit, includeAddOn, requireWorkHours);
    },

    haveSpecificInvoicedAmounts: function(unit) {
        return this.workReportCollection.haveSpecificInvoicedAmounts(unit);
    },

    haveOnlyInvoicedAmounts: function(unit) {
        return this.workReportCollection.haveOnlyInvoicedAmounts(unit);
    },

    haveAnyAmounts: function(unit) {
        return this.workReportCollection.haveAnyAmounts(unit);
    },

    sumInvoicedPrice: function(unit, onlyInvoiced, onlyWorkHours) {
        return this.workReportCollection.sumInvoicedPrice(unit, onlyInvoiced, onlyWorkHours); // TODO JOBS
    },

    sumAmountsToInvoice: function (unit) {
        return this.workReportCollection.sumAmountsToInvoice(unit); // TODO JOBS
    },

    isPriced: function(unit) {
        return this.workReportCollection.isPriced(unit);
    },

    haveAnyAmounts: function(unit) {
            return this.workReportCollection.haveAnyAmounts(unit);
    },

    fetchAndCache: function(options) {
        //console.log("Attestables Collection:","FetchAndCache Jobs and WorkReports")
        var self = this;
        self.setupJobs();
        self.setupWorkReports();
        var result = [];
        return $.when(self.jobCollection.fetchAndCache(options).success(function() {
            //console.log("Attestables Collection:", "Finished fetchAndCache Jobs: found " + self.jobCollection.models.length + " jobs.")
            for (var i in self.jobCollection.models) {
                var attestable = new Attestable(null,{id: self.jobCollection.models[i].id});
                attestable.setFromJob(self.jobCollection.models[i]);
                result.push(attestable);
            }
        }), self.workReportCollection.fetchAndCache(options).success(function() {
            //console.log("Attestables Collection:", "Finished fetchandCache WorkReports: found " + self.workReportCollection.models.length + " reports.")
            for (var i in self.workReportCollection.models) {
                var attestable = new Attestable(null,{id: self.workReportCollection.models[i].id});
                attestable.setFromWorkReport(self.workReportCollection.models[i]);
                result.push(attestable);
            }
        })).then(function (success) {
            //console.log("Attestables Collection:", "Fetching Attestables completed, found " + self.models.length + " attestables");
            self.setReportsToJob();
            self.reset(result);
        });
    },

    where: function(query) {
        var jobs = [];
        if (query.userId)
            jobs = this.jobCollection.filter(
                function(job){ return job.get('resources') && job.get('resources').filter(
                    function(resource){ return resource.userId == query.userId }).length > 0});
        else if (query.vehicleId)
            jobs = this.jobCollection.filter(
                function(job){ return job.get('resources') && job.get('resources').filter(
                    function(resource){ return resource.vehicleId == query.vehicleId }).length > 0});
        else
            jobs = this.jobCollection.where(query);
        
        var workReports = this.workReportCollection.where(query);
        var models = _.clone(this.models);
        var result = [];
        for(var i = 0; i < models.length; i++) {
            for (var j = 0; j < jobs.length; j++) {
                if (models[i] && jobs[j] && models[i].get("id") === jobs[j].get("id")) {
                    var model = models[i]
                    result.push(model);
                }
            }
            for (var j = 0; j < workReports.length; j++) {
                if (models[i] && workReports[j] && models[i].get("id") === workReports[j].get("id")) {
                    var model = models[i]
                    result.push(model);
                }
            }
        }
        return result;
    },

    setReportsToJob: function() {
        for(var i = 0; i < this.jobCollection.models.length; i++) {
            var job = this.jobCollection.models[i];
            job.reports = []
            for (var j = 0; j < this.models.length; j++) {
                var report = this.models[j];
                if (typeof report.get("jobId") !== "undefined" && report.get("jobId") === job.get("id")) {
                    job.reports.push(report);
                }
            }
        }
    }
});
